// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__JfgVt","info":"Note_info__23Z2B","note":"Note_note__Eli2-","actions":"Note_actions__AaAFg"};